module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/secondary-2ee4722fa6fb5468410e45da2acc9223.png";